import React from "react";
import { PropTypes } from "prop-types";
import { themes } from "../../theme";

const PhoneSupportIcon = ({ children, color, ...props }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
  >
    {children}
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        {...color !== "currentColor" && { fillOpacity: ".65" }}
        fillRule="nonzero"
        d="M15,22 L15,23.5 C15,23.7761424 14.7761424,24 14.5,24 L9.5,24 C9.22385763,24 9,23.7761424 9,23.5 L9,20.5 C9,20.2238576 9.22385763,20 9.5,20 L14.5,20 C14.7761424,20 15,20.2238576 15,20.5 L15,21 L17.4951185,21 C18.3288037,21 19,20.3295796 19,19.5 L19,18 L18.5,18 C18.2238576,18 18,17.7761424 18,17.5 L18,7.5 C18,7.22385763 18.2238576,7 18.5,7 L18.9291111,7 C18.4438815,3.60770586 15.5264719,1 12,1 C8.47352809,1 5.55611852,3.60770586 5.07088886,7 L5.5,7 C5.77614237,7 6,7.22385763 6,7.5 L6,17.5 C6,17.7761424 5.77614237,18 5.5,18 L3,18 C1.34010996,18 2.27373675e-13,16.6634543 2.27373675e-13,15 L2.27373675e-13,10 C2.27373675e-13,8.34010996 1.33654573,7 3,7 L4.06189375,7 C4.55399184,3.05368842 7.92038235,0 12,0 C16.0796177,0 19.4460082,3.05368842 19.9381062,7 L21,7 C22.6634543,7 24,8.34010996 24,10 L24,15 C24,16.6634543 22.65989,18 21,18 L20,18 L20,19.5 C20,20.8821234 18.8808297,22 17.4951185,22 L15,22 Z M19,8 L19,17 L21,17 C22.1082006,17 23,16.1105725 23,15 L23,10 C23,8.89179941 22.1105725,8 21,8 L20,8 L19,8 Z M5,8 L4,8 L3,8 C1.88942753,8 1,8.89179941 1,10 L1,15 C1,16.1105725 1.89179941,17 3,17 L5,17 L5,8 Z M9,8.5 C9,8.22385763 9.22385763,8 9.5,8 C9.77614237,8 10,8.22385763 10,8.5 L10,10.5 C10,10.7761424 9.77614237,11 9.5,11 C9.22385763,11 9,10.7761424 9,10.5 L9,8.5 Z M8.0527864,13.7236068 C7.92929178,13.4766175 8.02940395,13.176281 8.2763932,13.0527864 C8.52338245,12.9292918 8.82371897,13.029404 8.9472136,13.2763932 C9.04592874,13.4738235 9.27590074,13.7984899 9.64468192,14.1262953 C10.2604843,14.6736753 11.0355056,15 12,15 C12.9644944,15 13.7395157,14.6736753 14.3553181,14.1262953 C14.7240993,13.7984899 14.9540713,13.4738235 15.0527864,13.2763932 C15.176281,13.029404 15.4766175,12.9292918 15.7236068,13.0527864 C15.970596,13.176281 16.0707082,13.4766175 15.9472136,13.7236068 C15.7959287,14.0261765 15.4946507,14.4515101 15.0196819,14.8737047 C14.2292343,15.5763247 13.2230056,16 12,16 C10.7769944,16 9.77076568,15.5763247 8.98031808,14.8737047 C8.50534926,14.4515101 8.20407126,14.0261765 8.0527864,13.7236068 Z M14,8.5 C14,8.22385763 14.2238576,8 14.5,8 C14.7761424,8 15,8.22385763 15,8.5 L15,10.5 C15,10.7761424 14.7761424,11 14.5,11 C14.2238576,11 14,10.7761424 14,10.5 L14,8.5 Z M10,23 L14,23 L14,21 L10,21 L10,23 Z"
      />
    </g>
  </svg>
);

PhoneSupportIcon.displayName = "PhoneSupportIcon";

PhoneSupportIcon.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string
};

PhoneSupportIcon.defaultProps = {
  children: null,
  color: themes.global.gray01
};

export default PhoneSupportIcon;
